<template>
    <div class="card card-custom gutter-b">
        <div class="card-header">
            <div class="card-title">
                Danh mục Level
            </div>
            <div class="card-title">
                <button
                    type="button"
                    class="font-weight-bold font-size-3 btn btn-success"
                    @click="openCreate"
                >
                    Thêm mới
                </button>
            </div>
        </div>
        <div class="card-body" v-loading="loading">
            <div class="example mb-10">
                <div class="row">
                    <div class="form-group col-md-3">
                        <div class="input-group">
                            <div class="input-group-prepend">
                <span class="input-group-text line-height-0 py-0">
                  <span class="svg-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                    >
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                            d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            opacity="0.3"
                        ></path>
                        <path
                            d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                        ></path>
                      </g>
                    </svg>
                  </span>
                </span>
                            </div>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Tên level"
                                v-model="formSearch.name"
                                aria-describedby="basic-addon2"
                                @keyup="handleFormSearch"
                            >
                        </div>
                    </div>

                    <div class="form-group col-md-3">
                        <div class="form-group">
                            <el-select
                                v-model="formSearch.type"
                                clearable
                                class="w-100"
                                placeholder="Loại"
                                @change="handleFormSearch"
                            >
                                <el-option :value="1" label="Chuyên môn"/>
                                <el-option :value="2" label="Quản trị"/>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="example-preview table-responsive">
                    <table class="table table-vertical-center">
                        <thead>
                        <tr>
                            <th>STT</th>
                            <th>Mã danh mục</th>
                            <th>Tên danh mục</th>
                            <th>Loại</th>
                            <th style="min-width: 60px">Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="data.length > 0" v-for="(item, key) in data" :key="item.id">
                            <td>{{ key + 1 }}</td>
                            <td>{{ item.id }}</td>
                            <td>{{ item.name }}</td>
                            <td>
                  <span
                      class="badge"
                      :class="item.type == 1 ? 'badge-success' : 'badge-danger'"
                  >
                    {{ item.type == 1 ? 'Chuyên môn' : 'Quản trị' }}
                  </span>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    title="Sửa"
                                    class="btn btn-sm btn-icon mr-2 btn-outline-info"
                                    @click="openEdit(item)"
                                >
                                    <i class="fas fa-pen-nib"></i>
                                </button>
                                <button
                                    @click="deleteLevelCategory(item.id)"
                                    href="javascript:"
                                    class="btn btn-sm btn-icon btn-outline-danger"
                                >
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="data.length === 0 && !loading">
                            <td colspan="6" class="event-title no-data">Chưa có dữ liệu</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="edu-paginate mx-auto text-center">
            <paginate
                v-model="page"
                :page-count="last_page"
                :page-range="3"
                :margin-pages="1"
                :click-handler="clickCallback"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
        </div>

        <el-dialog
            title="Sửa danh mục"
            :visible.sync="dialogEdit"
            width="600px"
            @close="resetEditForm"
        >
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tên danh mục</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="editForm.name"
                            placeholder="Nhập danh mục"
                        >
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Loại</label>
                        <el-select
                            v-model="editForm.type"
                            clearable
                            class="w-100"
                            placeholder="Chọn loại">
                            <el-option :value="1" label="Chuyên môn"/>
                            <el-option :value="2" label="Quản trị"/>
                        </el-select>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEdit = false">Hủy</el-button>
                <el-button type="primary" :loading="savingEdit" @click="saveEdit" class="text-white">Lưu</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="Thêm mới danh mục"
            :visible.sync="dialogCreate"
            width="600px"
            @close="resetCreateForm"
        >
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tên danh mục</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="createForm.name"
                            placeholder="Nhập tên danh mục"
                        >
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Loại</label>
                        <el-select
                            v-model="createForm.type"
                            clearable
                            class="w-100"
                            placeholder="Chọn loại"
                        >
                            <el-option :value="1" label="Chuyên môn"/>
                            <el-option :value="2" label="Quản trị"/>
                        </el-select>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCreate = false">Hủy</el-button>
                <el-button type="primary" :loading="savingCreate" class="text-white" @click="saveCreate">Lưu</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import "@/assets/sass/custom/custom_event.scss";
import Swal from "sweetalert2";
import {
    CREATE_USER_LEVEL_CATEGORY,
    GET_USER_LEVEL_CATEGORY,
    UPDATE_USER_LEVEL_CATEGORY,
    DELETE_USER_LEVEL_CATEGORY
} from "@/core/services/store/level/level.module";

export default {
    name: "LevelCategoryList",
    data() {
        return {
            formSearch: {
                name: "",
                type: "",
            },
            departments: [],
            data: [],
            page: 1,
            last_page: 1,
            loading: false,

            dialogEdit: false,
            savingEdit: false,
            editForm: {
                id: null,
                name: "",
                type: "",
            },

            dialogCreate: false,
            savingCreate: false,
            createForm: {
                name: "",
                type: "",
            },
        };
    },
    mounted() {
        this.getListLevelCategory();
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý Level", route: "level-category-list"},
            {title: "Danh sách Level"},
        ]);
    },
    methods: {
        handleFormSearch() {

            this.page = 1;
            this.getListLevelCategory();
        },
        getListLevelCategory() {
            this.loading = true;
            const payload = {
                page: this.page,
                name: this.formSearch.name,
                type: this.formSearch.type,
            };

            this.$store
                .dispatch(GET_USER_LEVEL_CATEGORY, payload)
                .then((res) => {
                    this.data = res.data.data;
                    this.last_page = res?.last_page || 1;
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        clickCallback(page) {
            this.page = page;
            this.getListLevelCategory();
        },
        openEdit(item) {
            this.dialogEdit = true;
            this.editForm = {
                id: item.id,
                name: item.name ?? "",
                type: typeof item.type === "number" ? item.type : (item.type ? 1 : 0),
            };
        },
        openCreate() {
            this.dialogCreate = true;
            this.resetCreateForm();
        },
        resetEditForm() {
            this.editForm = {
                id: null,
                name: "",
                type: "",
            };
            this.savingEdit = false;
        },
        resetCreateForm() {
            this.createForm = {
                name: "",
                type: "",
            };
            this.savingCreate = false;
        },
        saveCreate() {
            if (!this.createForm?.name || !this.createForm?.type) return;

            this.savingCreate = true;
            this.$store
                .dispatch(CREATE_USER_LEVEL_CATEGORY, this.createForm)
                .then((res) => {
                    this.dialogCreate = false;
                    this.$bvToast?.toast?.("Thêm mới thành công", {
                        title: "Thêm mới",
                        variant: "success",
                        solid: true,
                    });
                    this.getListLevelCategory();
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.savingCreate = false;
                });
        },
        saveEdit() {
            if (!this.editForm?.id) return;

            this.savingEdit = true;

            const index = this.data.findIndex((x) => x.id === this.editForm.id);
            if (index !== -1) {
                this.$set(this.data, index, {
                    ...this.data[index],
                    name: this.editForm.name,
                    type: this.editForm.type,
                });
            }

            this.$store
                .dispatch(UPDATE_USER_LEVEL_CATEGORY, this.editForm)
                .then((res) => {
                    this.savingEdit = false;
                    this.dialogEdit = false;
                    this.$bvToast?.toast?.("Cập nhật thành công", {
                        title: "Sửa",
                        variant: "success",
                        solid: true,
                    });
                    this.getListLevelCategory();
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });

        },
        deleteLevelCategory(id) {
            Swal.fire({
                title: "Bạn chắc chắn muốn xóa?",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Không",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch(DELETE_USER_LEVEL_CATEGORY, id)
                        .then((res) => {
                            if (res.error) {
                                this.$bvToast.toast(res.message, {
                                    title: "Xóa",
                                    variant: "danger",
                                    solid: true,
                                });
                            } else {
                                this.$bvToast.toast(res.message, {
                                    title: "Xóa",
                                    variant: "success",
                                    solid: true,
                                });
                                this.getListLevelCategory();
                            }
                        })
                        .catch((err) => {
                            this.$bvToast.toast(err?.data?.message || "Có lỗi xảy ra", {
                                title: "Xóa",
                                variant: "danger",
                                solid: true,
                            });
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
.no-data {
    text-align: center;
}
</style>

